// extracted by mini-css-extract-plugin
module.exports = {"attachmentItem":"Attachments_attachmentItem__87722","icon":"Attachments_icon__e2900","attachmentSection":"Attachments_attachmentSection__0e4b5"};